var map = {
	"./archive.svg": 356,
	"./audio.svg": 357,
	"./doc.svg": 358,
	"./excel.svg": 359,
	"./folder.svg": 360,
	"./generic.svg": 361,
	"./image.svg": 362,
	"./json.svg": 363,
	"./layered.svg": 364,
	"./pdf.svg": 365,
	"./picture.svg": 366,
	"./presentation.svg": 367,
	"./video.svg": 368,
	"./xml.svg": 369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 636;